import { Menu, Bell, HelpCircle } from "lucide-react";

const ModuleNavbar = () => {
  return (
    <header className="flex h-16 w-full items-center justify-between border-b border-slate-200 bg-white px-6 py-3">
      {/* Left: Menu + Welcome */}
      <div className="flex items-center gap-4">
        <button
          type="button"
          className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-50 hover:text-slate-700 md:hidden"
        >
          <Menu size={20} />
        </button>
        <div>
          <h2 className="text-sm font-semibold text-slate-800 flex items-center gap-1.5">
            Welcome back, Babulal <span className="animate-bounce">👋</span>
          </h2>
          <p className="text-[11px] text-slate-400">
            Here's what's happening with your employment data today.
          </p>
        </div>
      </div>



      {/* Right: Notifications, Help, Profile */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2 border-r border-slate-200 pr-4">
          <button
            type="button"
            className="relative rounded-lg p-2 text-slate-500 hover:bg-slate-50 hover:text-slate-700"
          >
            <Bell size={18} />
            <span className="absolute right-1 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[9px] font-bold text-white">
              3
            </span>
          </button>
          <button
            type="button"
            className="rounded-lg p-2 text-slate-500 hover:bg-slate-50 hover:text-slate-700"
          >
            <HelpCircle size={18} />
          </button>
        </div>

        {/* Profile Avatar */}
        <div className="flex items-center gap-2.5">
          <div className="relative">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#147db5] text-xs font-bold text-white shadow-xs">
              BT
            </div>
            <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-emerald-500 border-2 border-white" />
          </div>
          <div className="hidden text-left xl:block">
            <p className="text-xs font-semibold text-slate-700 leading-none">
              Babulal Tandure
            </p>
            <span className="mt-0.5 block text-[9px] font-medium text-slate-400">
              HR Administrator
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ModuleNavbar;
